<!--
 * @Author: chencong
 * @Date: 2020-09-8 17:11:24
 * @LastEditTime: 2020-12-28 10:00:30
 * @LastEditors: ShiWeiShan
 * @Description: 上传缴费申请流程图
 * @FilePath: \fs-js-pcweb-user\src\components\reviewFlowChart\index.vue
-->
<template>
  <div class="dialog">
    <div class="Workflow-box">
      <div class="Workflow-box-up">
        <span>
          当前状态：
          <template>
            <i v-if="billData.process_status == '1'">开始</i>
            <i v-if="billData.process_status == '2'">行政部门复核中</i>
            <i v-if="billData.process_status == '3'">行政部门已复核</i>
            <i v-if="billData.process_status == '4'">行政部门审核中</i>
            <i v-if="billData.process_status == '5'">行政部门审核不通过</i>
            <i v-if="billData.process_status == '6'">结束</i>
          </template>
        </span>
        <p
          v-if="billData.process_status == '1'"
        >行政部门已下发超计划缴费清单，如若对下达的缴费清单有异议，请在收到缴费通知的20日内发起水量复核申请，若若对下达的缴费清单无异议，请尽快缴费并上传缴费凭证。</p>
        <p v-if="billData.process_status == '2'">已提交用水量复核申请，等待行政部门复核。</p>
        <p v-if="billData.process_status == '3'">行政部门已复核并重新下发缴费清单，请尽快缴费并上传缴费凭证。</p>
        <p v-if="billData.process_status == '4'">已上传缴费清单，等待行政部门审核。</p>
        <p v-if="billData.process_status == '5'">缴费凭证审核不通过，请核实缴费数额，并重新上传缴费凭证。</p>
        <p v-if="billData.process_status == '6'">已完成缴费。</p>
      </div>
      <div class="Workflow-box-down">
        <img
          src="../../assets/images/paycost/start.png"
          class="Workflow-img"
          v-if="billData.process_status == '1'"
        />
        <img
          src="../../assets/images/paycost/review_stay.png"
          class="Workflow-img"
          v-if="billData.process_status == '2'"
        />
        <img
          src="../../assets/images/paycost/review_has.png"
          class="Workflow-img"
          v-if="billData.process_status == '3'"
        />
        <img
          src="../../assets/images/paycost/audit_stay.png"
          class="Workflow-img"
          v-if="billData.process_status == '4'"
        />
        <img
          src="../../assets/images/paycost/audit_has.png"
          class="Workflow-img"
          v-if="billData.process_status == '5'"
        />
        <img
          src="../../assets/images/paycost/end.png"
          class="Workflow-img"
          v-if="billData.process_status == '6'"
        />
      </div>
      <div class="Workflow-box-footer">
        <el-button
          type="success"
          plain
          @click="handlestatubtn('pay')"
          v-if="billData.process_status == '1' || billData.process_status == '3' || billData.process_status == '5'"
        >上传缴费申请</el-button>
        <el-button
          type="success"
          plain
          @click="handlestatubtn('declare')"
          v-if="billData.process_status == '1'"
        >水量复核申请</el-button>
      </div>
    </div>
    <common-dialog
      v-if="detreviewdialog"
      :visible.sync="detreviewdialog"
      append-to-body
      cover
      :title="dialog_title"
      :width="dialig_width"
    >
      <!-- 水量复核申请 -->
      <bill-recheck-form
        v-if="dialogname == 'declare'"
        @successThen="rechecSuccessThen"
        @cancel="detreviewdialog=false"
        :billData="billData"
      ></bill-recheck-form>
      <!-- 缴费 -->
      <bill-upload-form
        v-else-if="dialogname === 'pay'"
        @successThen="rechecSuccessThen"
        @cancel="detreviewdialog=false"
        :billData="billData"
      ></bill-upload-form>
    </common-dialog>
  </div>
</template>

<script>
import { A_ADD_Waterreceipt } from '@/assets/js/axiosPresets'
import billRecheckForm from "@/components/applyForm/billRecheckForm" // 水量复核申请
import billUploadForm from "@/components/applyForm/billUploadForm" // 水量复核申请
export default {
  components: {
    billRecheckForm,
    billUploadForm
  },
  props: {
    billData: {
      type: Object
    }
  },
  data () {
    return {
      visiblesync: false, // 水量复核申请状态显示和隐藏
      // planprocess_status: "", // 水量复核申请状态
      dialogname: "", // 名称(做判断)
      dialog_title: "",
      detreviewdialog: false,
      dialig_width: ""
    }
  },
  methods: {
    // 功能：按钮事件
    handlestatubtn (e) {
      this.dialogname = e
      switch (e) {
        case 'declare':
          this.dialog_title = '水量复核申请'
          this.dialig_width = '1200px'
          break
        case 'pay':
          this.dialog_title = '上传缴费申请'
          this.dialig_width = '800px'
          break
      }
      this.detreviewdialog = true
    },
    // 复核成功后操作
    rechecSuccessThen () {
      setTimeout(() => {
        this.detreviewdialog = false
      }, 0)
      this.$emit('successThen')
    }
  }
}
</script>
